import {useState} from "react";

// @material-ui/core components
import { makeStyles } from "tss-react/mui";

// core components
import Button from "../CustomButtons/Button";
import Image from "next/image.js";
import Link from "next/link.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// local assets
import saveIcon from "../../public/img/forums/icons/saveIconBlue.png";
import linkIcon from "../../public/img/forums/icons/linkIcon.png";
import deleteIcon from "../../public/img/forums/icons/deleteIcon.png";
import shareLinkIcon from "../../public/img/forums/icons/shareLinkIcon.png";
import linkedinIcon from "../../public/img/forums/icons/linkedinIcon.png";
import facebookIcon from "../../public/img/forums/icons/facebookIcon.png";
import instagramIcon from "../../public/img/forums/icons/instagramIcon.png";
import whatsappIcon from "../../public/img/forums/icons/whatsappIcon.png";
import ForumsSuccessModal from "../ForumsSuccessModal/ForumsSuccessModal.js";
import {buildSlug} from "../../util/url";

const useStyles = makeStyles()(styles);

export default function ForumsModalOptions(props) {
    const { classes, cx } = useStyles();
    const modalType = props.type;
    const handleDelete = props.handleDelete;
    const {topic } = props;
    const [shareSuccess, setShareSuccess] = useState(false);

    const handleSave = () => {
        props.setSaved(true);
        props.onClose();
    }

    const handleShare = () => {
        const urlString = `${window.location.origin}/community/${buildSlug(props.community)}-${topic.subCatId}/topic/${buildSlug(topic.topicTitle)}-${topic.topicId}`;
        navigator.clipboard.writeText(urlString);
        setShareSuccess(true);
    }

    const handleShareClose = () => {
        setShareSuccess(false);
        props.onClose();
    }

    return (
        <>
            {modalType === "save" &&
                <div className={classes.modalContent}>
                    <Image className={classes.modalIcon} src={saveIcon} alt={"save-icon"} width={30} height={30} />
                    <p className={classes.modalTitle}>Save this post</p>
                    <p className={classes.modalText}>Save this post to your profile</p>
                    <Button className={cx(classes.darkButton + " " + classes.mediumButton)} onClick={handleSave}>Save</Button>
                </div>
            }
            {modalType === "share" &&
                <div className={classes.modalContent}>
                    <Image className={classes.modalIcon} src={linkIcon} alt={"share-icon"} width={40} height={40} />
                    <p className={classes.modalTitle}>Share this post</p>
                    <p className={classes.modalText}>Help others by sharing this post.</p>
                    <div className={classes.modalIconsContainer}>
                        <Button className={cx(classes.modalIcon + " " + classes.transparentButton)} onClick={handleShare}>
                            <Image className={classes.modalIcon} src={shareLinkIcon} alt={"share-link-icon"} width={50} height={50} />
                        </Button>
                        {/* Currently sharing not supported. May be added later */}
                        {/* <Link className={classes.modalIcon} href="#">
                            <Image className={classes.modalIcon} src={instagramIcon} alt={"instagram-icon"} width={50} height={50} />
                        </Link>
                        <Link className={classes.modalIcon} href="#">
                            <Image className={classes.modalIcon} src={facebookIcon} alt={"facebook-icon"} width={50} height={50} />
                        </Link>
                        <Link className={classes.modalIcon} href="#">
                            <Image className={classes.modalIcon} src={linkedinIcon} alt={"linkedin-icon"} width={50} height={50} />
                        </Link>
                        <Link className={classes.modalIcon} href="#">
                            <Image className={classes.modalIcon} src={whatsappIcon} alt={"whatsapp-icon"} width={50} height={50} />
                        </Link> */}
                    </div>
                </div>
            }
            {modalType === "delete" &&
                <div className={classes.modalContent}>
                    <Image className={classes.modalIcon} src={deleteIcon} alt={"delete-icon"} width={30} height={30} />
                    <p className={classes.modalTitle}>Are you sure you want to delete?</p>
                    <p className={classes.modalText}>This action cannot be undone, and the content will be permanently removed.</p>
                    <div className={classes.modalTagContainer}>
                        <Button className={classes.deleteButton} onClick={handleDelete}>Delete</Button>
                        <Button className={classes.cancelButton} onClick={props.onClose}>Cancel</Button>
                    </div>
                </div>
            }
            <ForumsSuccessModal open={shareSuccess} onClose={handleShareClose} type={"share"} community={null} question={null}/>
        </>
    )
}

